
import { Component, Vue, Watch } from "vue-property-decorator";
import QuestionCard from "@/components/question/QuestionCard.vue"; //题卡
import CandidateListForm from "@/lib/form/candidate/CandidateListForm"; //候选人列表 查询参数
import { Candidate } from "@/lib/model/exam/result"; //候选人信息 model
import { CandidateResult, Exam } from "@/lib/model/exam/result"; //候选人试卷内容 model
import { Answer } from "@/lib/model/exam/result"; //候选人答案内容
import { Question } from "@/lib/model/question/question"; //题目model
import request from "@/lib/request/request";
import Url from "@/lib/common/url";
import QuestionTag from "../../components/question/QuestionTag.vue";
import track from "@/lib/common/track";
import dayjs from "dayjs";
import { CompanyConfig } from "@/lib/common/acm";
import Auth from "@/lib/common/auth";
import { Permission } from "@/lib/model/common";
import EchartsDisc from "@/views/paper/components/echarts-disc.vue";

enum auditTextEnum {
  "待评估",
  "通过",
  "待定",
  "拒绝"
}
//异常项
enum errorEnum {
  "screenshot" = "多次截屏",
  "replacePerson" = "疑似换人",
  "readCheating" = "疑似念稿",
  "faceCheck" = "身份认证失败",
  "bgCheck" = "背调不通过",
  "bgCheckSocial" = "有社会安全风险",
  "bgCheckFinancial" = "有金融风险",
  "finger" = "手部检测未通过",
  "webJump" = "Web疑似切屏",
  "faceDetection" = "露脸检测未通过"
}
@Component({ components: { QuestionCard, QuestionTag, EchartsDisc } })
export default class PaperMark extends Vue {
  q = 0;
  showPOP = false;
  showBlack = false;
  scoreShow = false;
  showScoreBlack = false;
  fen = 1;
  questionList: Question[] = []; //所有题目
  answerList: Answer[] = []; //候选人的回答
  infoList: any[] = []; //头部个人信息
  connectCode = 0; //当前connectCode
  candidateListForm = new CandidateListForm();
  resultStatus = 0; //最终评定
  resultText = "";
  exam = new Exam();
  unLogin = true;
  reviewer = ""; //阅卷人
  waitingQList: Answer[] = []; //待阅题目
  canChange = false; //修改结果
  scoreAll = 0; //试卷总分
  scoreHandle = 0; //打分器的分值
  resultStatusHandle = 0; //手选结果
  resultTextHandle = ""; //手写评价
  showWarning = false;
  scrollTopBefore = 0;
  noAnswer = "未作答";
  startTime: any;
  endTime: any;
  paperInfo = new Candidate();
  playedIdList = {};
  hideAiScore = false; //隐藏ai打分
  WXtoken = ""; //微信嵌套页面token值
  connectCompanyId = 0; //根据链接码获取的companyId
  errorInfoList: any = []; //异常检测 截屏
  mkPower = true;
  mindData = new Answer();
  all = new CandidateResult();

  //是否隐藏手机号
  get isHidePhone() {
    return CompanyConfig.getInstance(this.connectCompanyId).isHidePhone === 1;
  }
  //评语是否必填
  get isMustText() {
    return (
      CompanyConfig.getInstance(this.connectCompanyId).isMustResultText === 1
    );
  }
  //评语最低字数
  get resultMinNumber() {
    return CompanyConfig.getInstance(this.connectCompanyId).resultTextMinNumber;
  }
  //总得分
  get totalScore() {
    let t = 0;
    this.answerList.forEach((d: any) => {
      t += Number(d.scoreHr) || 0;
    });
    return t < 0 ? 0 : t;
  }
  //其他权限  list以外的都算
  otherPowerList = [
    "姓名",
    "姓名/手机",
    "手机",
    "邮箱",
    "身份证号",
    "新建时间",
    "面试状态",
    "通知状态",
    "提交时间",
    "交卷方式",
    "负责人",
    "身份证号",
    "身份证",
    "身份证号后6位",
    "AI打分",
    "AI推荐",
    "评估结果",
    "得分",
    "面试官评分",
    "AI评估说明",
    "面试官结果"
  ];
  get paramListFilterByPower() {
    const res = this.infoList.filter(d => {
      return !(
        !this.$P.candidateInfo.other && !this.otherPowerList.includes(d.name)
      );
    });
    return res;
  }

  //限制最大分
  @Watch("scoreHandle", { immediate: true })
  limitMax(strScore: string) {
    let needFixNumber = false;
    //如果前面有零，去掉零
    if (/^0.{1,}$/.test(strScore)) {
      strScore = strScore.replace(/^0/g, "");
      needFixNumber = true;
    }

    if (!/^[-|+]?\d?$/.test(strScore)) {
      const match = /[-|+)]?\d*/.exec(strScore);
      if (match) strScore = match[0];
      else strScore = "0";
      needFixNumber = true;
    }

    if (needFixNumber) {
      this.scoreHandle = Number(strScore);
    }

    if (Number(strScore) > Number(this.questionList[this.q]?.score)) {
      // this.warn();
      this.scoreHandle = Number(this.questionList[this.q]?.score);
    }
  }
  //链接码对应公司ID
  getConnectCompanyId() {
    CandidateResult.getCid(Number(this.connectCode), this.tid).then(
      (res: any) => {
        this.connectCompanyId = res.companyId;
        if (Auth.token) {
          //获取用户权限
          Permission.getPermission({
            companyId: this.connectCompanyId
          }).then(d => {
            this.mkPower = d?.accountPower?.ai?.person?.judge;
          });
        }
      }
    );
  }

  //是否可修改结果
  setCanChange() {
    this.canChange = !(
      //公司配置不可修改 且 已阅过卷
      (
        this.exam.companySpecialConfig.auditRepeat === 2 &&
        this.resultStatus !== 0
      )
    );
  }
  //填空题答案
  blankAnswer(answer: any) {
    let t = ``;
    answer.blanks.forEach((d: any, i: number) => {
      t += `${i + 1}.（${d}）`;
      t += answer.blanksIsRight[i]
        ? `<span class="ok">正确</span>`
        : `<span class="no">错误</span>`;
    });
    return t;
  }
  //选择结果
  selectResult(d: number) {
    if (!this.canChange) return;
    if (!this.mkPower) {
      alert("您的账号没有评估候选人权限，如需开通权限请联系贵司系统管理员");
      return;
    }
    this.resultStatusHandle = d;
    this.showBlack = true;
    this.showPOP = true;
  }
  //打分
  setScore(index: number) {
    if (!this.canChange) {
      this.warn("已完成阅卷，不可修改。");
      return;
    }
    const scrollContainer = document.documentElement as HTMLElement;
    this.scrollTopBefore = scrollContainer.scrollTop;
    this.scoreShow = true;
    this.showScoreBlack = true;
    this.q = index;
    this.scoreHandle = this.answerList[this.q].scoreHr;
    //
  }
  //加分
  add() {
    this.scoreHandle++;
    if (Number(this.scoreHandle) > Number(this.questionList[this.q].score)) {
      // this.warn();
      this.scoreHandle--; //禁止超过最高分
      return;
    }
  }
  //确认打分
  scoreOk() {
    if (!Number(this.scoreHandle)) this.scoreHandle = 0;
    this.answerList[this.q].scoreHr = this.scoreHandle;
    this.closeScore();
  }
  closeScore() {
    this.scoreShow = false;
    this.showScoreBlack = false;
    const scrollContainer = document.documentElement as HTMLElement;
    scrollContainer.scrollTop = this.scrollTopBefore;
  }
  //防重复提示
  warn(t = "已达本题最高分！") {
    if (!this.showWarning) {
      this.$message.warning(t);
      this.showWarning = true;
      setTimeout(() => {
        this.showWarning = false;
      }, 3000);
    }
  }
  //设备查询
  isMobile(): boolean {
    const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    const isAndroid = /(Android)/i.test(navigator.userAgent);
    return isIos || isAndroid;
  }
  notAllow = false;
  async created() {
    this.notAllow = Boolean(this.$route?.query?.judgeOutId && this.isMobile()); //多人评估禁用h5
    if (this.notAllow) {
      this.$message.warning("请在电脑端打开此链接");
      return;
    }
    document.title = "AI面试";
    //去掉ios的ip展示
    window.alert = function(name) {
      const iframe = document.createElement("IFRAME");
      iframe.style.display = "none";
      iframe.setAttribute("src", "data:text/plain,");
      document.documentElement.appendChild(iframe);
      window.frames[0].window.alert(name);
      iframe?.parentNode?.removeChild(iframe);
    };
    await Permission.getPerm(); //拉下用户权限（非需登录页面，没有头所以独立拉一下）
  }
  mounted() {
    const params = this.$route.query;
    //鉴权
    if (this.$route.query.tid) {
      this.tid = String(this.$route.query.tid);
    }
    //小程序环境token
    this.WXtoken = (params?.WXtoken as string) || "";
    if (this.WXtoken) {
      Auth.token = this.WXtoken;
    }
    this.reviewer = (params?.user as string) || "";
    this.connectCode = Number(params?.connectCode);
    this.getConnectCompanyId();

    //做未登录
    this.unLogin = true;
    this.selectCandidate({ connectCode: params.connectCode });
    // }
    this.startTime = new Date(); // 开始时间
  }

  //监听video播放
  listenVideo() {
    try {
      for (const refName in this.$refs) {
        if (refName.indexOf("video") != -1) {
          this.$refs[refName]?.[0].addEventListener("play", () => {
            try {
              //记录播放过的视频
              const index = Number(refName.replace("video", ""));
              this.playedIdList[this.questionList[index].questionId] = true;
              //暂停其他video
              this.pauseOther(refName);
            } catch (e) {
              console.log(e);
            }
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  //暂停其他video
  pauseOther(refName: string) {
    for (const ref in this.$refs) {
      if (ref.includes("video") && ref !== refName) {
        (this.$refs[ref] as HTMLMediaElement)?.[0]?.pause();
      }
    }
  }

  //加载试卷
  selectCandidate(d: any) {
    if (!d.connectCode) {
      console.log("无链接码！");
      return; //链接码必须
    }
    this.connectCode = d.connectCode;
    Url.setQuery("connectCode", String(this.connectCode)); //用户刷新保持当前卷子
    this.getCandidateInfo();
  }
  //获取顶部个人信息
  getCandidateInfo() {
    Candidate.get({
      connectCode: this.connectCode,
      reviewer: this.reviewer,
      tid: this.tid
    }).then(res => {
      this.paperInfo = res;
      this.infoList = res.paramList.filter(d => {
        return (
          d.isShow === 1 &&
          (!this.isHidePhone || (this.isHidePhone && d.name !== "手机"))
        );
      });
      this.resultStatus = res.auditStatus;
      this.resultText = res.auditDesc;
      //截屏等 异常检测
      this.errorInfoList = [];
      if (this.paperInfo.errorInfoList.length) {
        this.paperInfo.errorInfoList.forEach((d: any) => {
          if (!errorEnum[d.task]) return;
          if (d.result === 2) return;
          this.errorInfoList.push({
            name: errorEnum[d.task],
            result: d.result
          });
        });
      }
      // 下一步加载试卷
      this.getCandidatePaper();
    });
  }
  //获取试卷内容
  getCandidatePaper() {
    CandidateResult.get({
      connectCode: this.connectCode,
      reviewer: this.reviewer,
      tid: this.tid
    }).then(res => {
      this.scoreAll = res.scoreAll;
      this.questionList = res.questionList;
      this.answerList = res.answerList;
      this.exam = res.exam;
      this.all = res;
      //配置了隐藏AI打分 且 未阅卷
      this.hideAiScore =
        this.paperInfo.auditStatus === 0 && res.exam.hideAiScore;
      //处理隐藏hr打分
      res.answerList.forEach(d => {
        const flag = this.hideAiScore && d.type === 6;
        d.scoreHr = flag ? undefined : d.scoreHr;
      });
      this.$nextTick(() => {
        this.listenVideo();
      });
      this.setCanChange(); //是否可修改结果
      this.setMindData(); //标准心理测试结果
    });
  }
  getRes(d: number) {
    return auditTextEnum[d];
  }
  //关闭提交框
  close() {
    this.showPOP = false;
    this.$nextTick(() => {
      setTimeout(() => {
        this.showBlack = false;
      }, 100);
    });
  }
  tid = "";
  //交卷
  submit() {
    try {
      this.endTime = new Date(); // 开始时间
      const usedTime = (this.endTime - this.startTime) / 1000; // 相差的毫秒数
      const playedIdList = Object.keys(this.playedIdList);

      const logParams = {
        connectCode: this.connectCode,
        action: "audit_track",
        extraData: {
          candidate_id: this.paperInfo.candidateId,
          duration: usedTime,
          active_duration: usedTime,
          startTime: dayjs(this.startTime).format("YYYY-MM-DD HH:mm:ss"),
          endTime: dayjs(this.endTime).format("YYYY-MM-DD HH:mm:ss"),
          audit_result: this.getRes(this.resultStatusHandle),
          score_all: this.totalScore,
          platform: "h5",
          played_id_list: playedIdList
        }
      };
      request.post("/aiExam/candidatePublic/log", logParams);

      track("audit_result", {
        exam_id: this.candidateListForm ? this.candidateListForm.examId : 0,
        exam_name: this.exam.name,
        exam_remark: this.exam.remark,
        candidate_id: this.paperInfo.candidateId,
        use_time: usedTime,
        audit_result: this.getRes(this.resultStatusHandle),
        score_all: this.totalScore,
        platform: "H5",
        played_id_list: playedIdList
      });

      if (this.resultTextHandle.length > 0) {
        track("audit_page_interact", {
          exam_id: this.candidateListForm ? this.candidateListForm.examId : 0,
          exam_name: this.exam.name,
          exam_remark: this.exam.remark,
          candidate_id: this.paperInfo.candidateId,
          operation_type: "录入评估结果",
          operation_name: this.resultTextHandle
        });
      }
    } catch (e) {
      console.log(e);
    }
    //评价必填 老版
    if (
      this.exam.companySpecialConfig.auditDescMust === 1 &&
      this.resultTextHandle.length < 1
    ) {
      this.$message.warning("请填写总体评价！");
      return;
    }
    //新 公司acm配置 必填校验
    if (this.isMustText && this.resultTextHandle.length < 1) {
      this.warn("请输入总体评价");
      return;
    }
    // 评价最少字数
    if (
      this.resultMinNumber !== 0 &&
      this.resultTextHandle.length < this.resultMinNumber
    ) {
      this.warn("总体评价至少需" + this.resultMinNumber + "个字");
      return;
    }

    //未打分题目
    const notMarkIndex = this.answerList.findIndex(d => {
      return d.scoreHr === undefined;
    });
    //AI未完成打分时  且 hr未打分
    if (notMarkIndex !== -1) {
      (this.$refs["qCard" + notMarkIndex]?.[0] as HTMLElement).scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
      this.warn("请给此题打分");
      this.close();
      // this.answerList.forEach(d => {
      //   d.showMarkTip = d.isScored === 0 ? true : false;
      // });
      return;
    }

    const list: any[] = [];
    let allLastScore = 0;

    this.answerList.forEach((d: Answer) => {
      if ([6, 8].includes(d.type)) {
        list.push({ questionId: d.questionId, score: d.scoreHr }); //只传视频 音频题
      }
      allLastScore += Number(d.scoreHr);
    });
    //HR 打tag
    const tagList: any[] = [];
    this.answerList.forEach((d: Answer) => {
      if (d.questionTagList.length) {
        tagList.push({
          questionId: d.questionId,
          questionTagList: d.questionTagList
        });
      }
    });
    const params: any = {
      connectCode: this.connectCode,
      auditStatus: this.resultStatusHandle,
      auditDesc: this.resultTextHandle,
      scoreList: list,
      tagList
    };
    params.score = allLastScore;
    params.connectCode = this.connectCode;
    params.reviewer = this.reviewer;
    params.tid = this.tid;
    request
      .post("aiExam/auditPublic/submit", params)
      .then((resp: { data: any }) => {
        if (resp.data.code === 0) {
          this.selectCandidate({ connectCode: params.connectCode }); //刷新
          this.$message.success("提交成功！");
          this.close();
          //
        } else {
          //
        }
      });
  }
  //asr内容
  asrText(list: any) {
    if (list.length === 0) {
      return "未识别出内容";
    }
    let text = "";
    list.forEach((d: any) => {
      text += d.txt;
    });
    return text;
  }

  //题目tag选中
  changeTag(item: any) {
    //已评分的卷子 不可修改
    if (this.resultStatus !== 0) {
      return;
    }
    item.hrResult = item.hrResult === 0 ? 1 : 0;
    //插入文本
    if (item.hrResult === 1) {
      this.resultAddText(item.tagName);
    }
  }
  //评语插入文本
  resultAddText(d: string) {
    //已有则不加
    if (this.resultTextHandle.indexOf(d) !== -1) return;
    //是否隔断前一句
    const t = this.resultTextHandle.slice(this.resultTextHandle.length - 1);
    console.log(t);
    d = [
      ",",
      ".",
      ";",
      "，",
      "。",
      "、",
      "；",
      "：",
      ":",
      "?",
      "？",
      "!",
      "！",
      "~",
      ""
    ].includes(t)
      ? d
      : "；" + d;
    this.resultTextHandle += d + "；";
    this.$message.success("已将此考察点加入总体评价");
  }
  //心理测评
  //标准心理结果
  setMindData() {
    this.mindData =
      this.all?.questionAnswerMap?.[106]?.[0]?.answer ?? new Answer();
  }
  //打开简历 新版字段
  async showAttachment(url: string) {
    const androidPdf =
      /(Android)/i.test(navigator.userAgent) && url?.slice(-3) === "pdf";
    if (
      url?.slice(-4) === "docx" ||
      url?.slice(-3) === "doc" ||
      url?.slice(-4) === "pptx" ||
      androidPdf
    ) {
      await this.sendRequest("/aiExam/common/previewDocUrl", { url }).then(
        (res: any) => {
          url = res?.data?.url;
        }
      );
    }
    document.location.href = url;
  }

  sendRequest(url: any, params = {}, method = "post") {
    return new Promise(function(resolve, reject) {
      request[method](url, params).then((resp: { data: any }) => {
        if (resp.data.code === 0) {
          resolve(resp.data);
        } else {
          reject(resp.data.message);
        }
      });
    }).catch(e => {
      console.log(e);
    });
  }
}
